/**
 * PageSkeleton — v.1-D §7.24.
 *
 * The shared loading placeholder. Mounts inside `ProtectedShell` while
 * `useAuth()` is loading, inside `AdminGate` while `useCurrentMember()` is
 * undefined, and inside the per-route `<Suspense>` boundary in `routes/index.tsx`
 * while a lazy page module resolves.
 *
 * The .skeleton CSS utility (in `styles/global.css`) supplies the shimmer
 * keyframe — we only declare geometry here.
 */
import type { JSX } from 'react';

export function PageSkeleton(): JSX.Element {
  return (
    <div style={{ padding: 32 }}>
      <div
        className="skeleton"
        style={{
          height: 56,
          marginBottom: 20,
          borderRadius: 'var(--radius-md)',
        }}
      />
      <div
        className="skeleton"
        style={{
          height: 400,
          borderRadius: 'var(--radius-signature)',
        }}
      />
    </div>
  );
}
